/**
 * CPI Escalation settings tab for the tenant detail panel.
 *
 * Displays CPI floor/cap configuration (currently read-only placeholder)
 * and directs users to configure CPI escalation entries in the Base Rent tab.
 */

export default function CpiTab() {
  return (
    <div className="bg-white rounded-xl border border-grove-300 p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-bark-700 mb-3">
        CPI Escalation Settings
      </h3>
      <p className="text-sm text-bark-400 mb-4">
        CPI-based rent escalations can be configured as entries in the Base Rent
        tab with type "CPI Escalation". Enter the annual percentage increase as
        the amount.
      </p>
      <div className="grid grid-cols-2 gap-4 max-w-md">
        <div>
          <label className="block text-xs font-medium text-bark-500 mb-1">
            CPI Floor (%)
          </label>
          <input
            type="number"
            className="w-full px-3 py-2 text-sm border border-grove-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-honey-400 tabular-nums"
            placeholder="0.0"
            disabled
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-bark-500 mb-1">
            CPI Cap (%)
          </label>
          <input
            type="number"
            className="w-full px-3 py-2 text-sm border border-grove-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-honey-400 tabular-nums"
            placeholder="5.0"
            disabled
          />
        </div>
      </div>
      <p className="text-xs text-bark-300 mt-3">
        CPI floor/cap editing coming soon.
      </p>
    </div>
  );
}
